import { PropsWithChildren } from 'react';
import { Action, FloatingActionBar } from '@frontend/adapto-actions';
import { Actions } from '@frontend/contact-actions';
import { useTranslation } from '@frontend/i18n';

interface Props {
  personId: string;
  locationId: string;
  hasNotes: boolean;
  optedOut: boolean;
  selected: boolean;
  onAddEditNote: () => void;
  onDelete: () => void;
  onSelect: () => void;
}

export const WaitListItemFloatingActions = ({
  children,
  personId,
  locationId,
  hasNotes,
  optedOut,
  selected,
  onAddEditNote,
  onDelete,
  onSelect,
}: PropsWithChildren<Props>) => {
  const { t } = useTranslation('schedule-quick-fill');
  return (
    <FloatingActionBar>
      <FloatingActionBar.Actions>
        {optedOut ? (
          <Actions.Call context={{ personId, locationId }} label={t('Click to Call')} />
        ) : !selected ? (
          <Action icon='select-all' label={t('Select')} onClick={onSelect} />
        ) : null}
        <Action
          icon={hasNotes ? 'edit' : 'add'}
          label={hasNotes ? t('Edit Note') : t('Add Note')}
          onClick={onAddEditNote}
        />
        <Action icon='trash' label={t('Remove From List')} onClick={onDelete} />
      </FloatingActionBar.Actions>
      <FloatingActionBar.Content>{children}</FloatingActionBar.Content>
    </FloatingActionBar>
  );
};
